import axios from "axios";
import qs from "qs";
import Constants from "common/Constants";
import { callLogout, checkPm } from "bridge/common/CommonBridge";
import nodeBase64 from "nodejs-base64-converter";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";
import { unregister } from "serviceWorker";
import { RestoreSharp } from "@material-ui/icons";

import useSpinner from "store/customHooks/useSpinner";
import { isDirectEntryUrl } from "utils/directEntry";
import { store } from "Root";
import { openSpinner, closeSpinner } from "../store/modules/common/spinnerReducer";

const envState = String(process.env.REACT_APP_ENV).trim() || "local";
export let ConstantsServer;
if (envState === "real") {
    ConstantsServer = require("common/Constants-real");
} else if (envState === "dev") {
    ConstantsServer = require("common/Constants-dev");
} else {
    ConstantsServer = require("common/Constants-local");
}
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const initApiHeader = (param) => {
    /**
     * const headerParam = {
     *   user_id: 'M100000702',
     * };
     */
    axios.defaults.headers.common["user-id"] = param.user_id;
    axios.defaults.headers.common["web-version"] = "0.0.1";
    axios.defaults.headers.common["Os"] = "I";

    if (param.CONTRACT_NUMBER && param.CUSTOMER_NUMBER) {
        axios.defaults.headers.common["CONTRACT_NUMBER"] = param.CONTRACT_NUMBER;
        axios.defaults.headers.common["CUSTOMER_NUMBER"] = param.CUSTOMER_NUMBER;
    }
    // axios.defaults.headers.common["Auth-Token"] = param["Auth-Token"];
};

export async function callPostAsync(headerParam, param, queryParam) {
    let response;
    initApiHeader(headerParam);
    const url = param.URL || "/common/api";
    param.REQUEST_API =
        encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);
    if (param.DOMAIN) {
    } else {
        param.DOMAIN = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;
    }
    if (
        param.HTTP_METHOD !== Constants.HTTP_METHOD.GET &&
        param.BODY !== null &&
        typeof param.BODY !== "string"
    ) {
        param.BODY = JSON.stringify(param.BODY);
    }
    try {
        // console.log(param);
        // console.log(url);
        // console.log(source.token);
        response = await axios.post(url, qs.stringify(param), { cancelToken: source.token });
    } catch (error) {
        console.error("CallPostAsync Error");
        return;
    }
    return response.data.RESP_RESULT;
}

// 사용법:
//     1. callPostSync를 호출하는 함수를 포함하는 함수를 async 연산자를 사용해 선언
//     2. callPostSync를 await로 호출합니다.
export async function callPostSync(headerParam, param, callback, queryParam) {
    await callPost(headerParam, param, callback, queryParam, true);
}

export function callPost(headerParam, param, callback, queryParam) {
    //공통 헤더 셋팅

    initApiHeader(headerParam);

    const url = param.URL || "/common/api";

    param.REQUEST_API =
        encodeURI(queryParam && injectQueryParam(param.REQUEST_API, queryParam)) || encodeURI(param.REQUEST_API);

    if (!param.DOMAIN) {
        param.DOMAIN = ConstantsServer.SERVER_DOMAIN.GW_SMARTALL_MID_DOMAIN;
    }
    //POST 일때, BODY가 있을때 param.BODY JSON형식 변환
    if (
        param.HTTP_METHOD !== Constants.HTTP_METHOD.GET &&
        param.BODY !== null &&
        typeof param.BODY !== "string"
    ) {
        param.BODY = JSON.stringify(param.BODY);
    }

    // FILE UPLOAD\
    // if (url === "/today/middleStudyToday") {
    //     console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
    //     console.log(headerParam);
    //     console.log(param);
    //     console.log(qs.stringify(param));
    //     // param = qs.stringify(param);
    //     // param = nodeBase64.encode(JSON.stringify(param));
    //     return axios({
    //         method: "POST",
    //         url: "/common/api",
    //         headers: headerParam,
    //         withCredentials: true,
    //         data: param,
    //     })
    //         .then((response) => {
    //             if (callback != null) {
    //                 return callback(response.data.RESP_RESULT, param);
    //             } else {
    //                 console.log(response.data.RESP_RESULT);
    //                 return response.data.RESP_RESULT;
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("File Upload Error");
    //             return;
    //         });
    // } else
    if (url === "/common/fileUpload") {
        let fileInfo = param.FORM_INFO;
        fileInfo.append("REQUEST_API", param.REQUEST_API);
        fileInfo.append("HTTP_METHOD", param.HTTP_METHOD);

        return axios({
            method: "POST",
            url: url,
            data: fileInfo,
            headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
                cache: false,
                processData: false,
                crossDomain: true,
            },
            withCredentials: true,
        })
            .then((response) => {
                if (callback != null) {
                    return callback(response.data.RESP_RESULT, param);
                } else {
                    console.log(response.data.RESP_RESULT);
                    return response.data.RESP_RESULT;
                }
            })
            .catch((error) => {
                const spinnerReducer = store.getState()?.spinnerReducer;
                if (spinnerReducer?.state) {
                    store.dispatch(closeSpinner());
                }

                console.error("File Upload Error");
                return Promise.reject(error);
            });
    } else if (url.includes("/login")) {
        param = nodeBase64.encode(JSON.stringify(param));

        return axios({
            method: "POST",
            url: url,
            data: param,
        })
            .then((response) => {
                if (callback != null) {
                    return callback(response.data.RESP_RESULT, param);
                } else {
                    console.log(response.data.RESP_RESULT);
                    return response.data.RESP_RESULT;
                }
            })
            .catch((error) => {
                console.error("LOGIN Error");
                return;
            });
    } else {
        return axios
            .post(url, qs.stringify(param), { cancelToken: source.token })
            .then((response) => {
                if (callback != null) {
                    return callback(response.data.RESP_RESULT, param);
                } else {
                    // console.log(response.data.RESP_RESULT);
                    return response.data.RESP_RESULT;
                }
            })
            .catch((error) => {
                const spinnerReducer = store.getState()?.spinnerReducer;
                if (spinnerReducer?.state) {
                    store.dispatch(closeSpinner());
                }

                if (param.REQUEST_API.includes("prfmVltnGuideLikedYn")) {
                    callback("error");
                    return;
                }
                //another Error Exception
                if (error.status) {
                    console.error(error.status + " : " + error.statusText);
                    return;
                }
                console.error(error);
            });
    }
}

const injectQueryParam = (api, param) => {
    if (typeof api !== "string") return;

    for (let key in param) {
        let regExp = new RegExp("{" + key + "}", "g");
        api = api.replace(regExp, param[key]);
    }
    return api;
};

//Request Interceptors
// axios.interceptors.request.use(
//     (config) => {
//         // 요청을 보내기 전에 수행할 일
//         // ...
//         axios.defaults.headers.common["web-version"] = localStorage.getItem("web-version") || "0.0.1";

//         return config;
//     },
//     (error) => {
//         // 오류 요청을 보내기전 수행할 일
//         console.log("Request Interceptor Error : ", error);
//         return Promise.reject(error);
//     }
// );

const getMembershipPauseInfo = (errorStatus) => {
    const customerNumber = localStorage.getItem("customerNumber");

    const queryParam = {
        MEMBER_CODE: customerNumber,
    };

    const param = {
        REQUEST_API: Constants.MEMBERSHIP_API.MEMBERSHIP_PAUSE_INFO,
        HTTP_METHOD: Constants.HTTP_METHOD.GET,
    };

    callPost({}, param, (response) => callbackGetMembershipPauseInfo(response, errorStatus), queryParam);
};

const callbackGetMembershipPauseInfo = (response, errorStatus) => {
    const popupMsg = response.RESP_RESULT.POPUP_MSG;

    console.error(`Response Interceptor ${errorStatus} Error`);
    source.cancel("Operation canceled by the user.");
    callLogout(popupMsg, errorStatus);
};

// [TEST] 에러 호출
// const triggerErrorRequest = async () => {
//     await axios
//         .get("/invalid/endpoint")
//         .then((response) => {})
//         .catch((error) => {
//             console.log("catch triggerErrorRequest :: ");

//             const spinnerReducer = store.getState()?.spinnerReducer;
//             if (spinnerReducer?.state) {
//                 store.dispatch(closeSpinner());
//             }

//             if (error.status) {
//                 console.error(error.status + " : " + error.statusText);
//                 return;
//             }
//             console.error(error);
//         });
// };

//Response Interceptors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // 오류 응답을 처리
        console.log("Response Interceptor Error : ", error.response.status);

        const spinnerReducer = store.getState()?.spinnerReducer;
        if (spinnerReducer?.state) {
            store.dispatch(closeSpinner());
        }

        /**
         * CMS 링크로 로그인 없이 들어온 화면(시험정보/시험성적)은 세션이 없어 401/403 이 정상적으로 나올 수 있다.
         * 여기서 전역 로그아웃을 태우면 저장된 로그인 정보까지 지우고 로그인 화면으로 튕기므로, 안내만 하고 끝낸다.
         */
        if (isDirectEntryUrl() && [401, 403, 420, 502].includes(error.response.status)) {
            console.error(`Response Interceptor ${error.response.status} Error (비로그인 직접 진입)`);
            AlertConfirmPopup({ type: "ALERT", msg: Constants.ERROR_MESSAGE.SERVER_ERROR });

            return Promise.reject(error);
        }

        let warningMsg = "";
        let errorMsg = "";
        if (error.response.status === 204) {
            warningMsg = error.response.statusText;
            console.warn(warningMsg);
        } else if (error.response.status === 404 || error.response.status === 400) {
            errorMsg = error.response.statusText;
            console.error("Response Interceptor 404 Error", errorMsg);
        } else if (error.response.status === 500) {
            errorMsg = error.response.statusText;
            console.error("Response Interceptor 500 Error", errorMsg);
            // window.location.reload();
        } else if (error.response.status === 401) {
            errorMsg = Constants.ERROR_MESSAGE.EXPIRED_LOGIN;
            console.error("Response Interceptor 401 Error", errorMsg);
            source.cancel("Operation canceled by the user.");
            callLogout(errorMsg);
        } else if (error.response.status === 403) {
            const errorMsg = Constants.ERROR_MESSAGE.DUPLICATE_LOGIN;
            console.error("Response Interceptor 403 Error", errorMsg);
            source.cancel("Operation canceled by the user.");
            callLogout(errorMsg, error.response.status);
        } else if (error.response.status === 502) {
            const errorMsg = Constants.ERROR_MESSAGE.SERVER_ERROR;
            console.error("Response Interceptor 502 Error", errorMsg);
            // const reqData = {
            //     title: "",
            //     type: "ALERT",
            //     msg: errorMsg,
            // };
            // checkPm(reqData);
            callLogout(errorMsg);
        } else if (error.response.status === 504) {
            const errorMsg = Constants.ERROR_MESSAGE.SLOW_NETWORK;
            console.error("Response Interceptor 504 Error", errorMsg);
            const reqData = {
                title: "",
                type: "ALERT",
                msg: errorMsg,
            };
            checkPm(reqData);
        } else if (error.response.status === 420) {
            getMembershipPauseInfo(error.response.status);
        }

        // return error.response.status;
        return Promise.reject(error);
    },
);
